export const baseURL = "http://hagzh.cn"

// export const baseURL = "http://ceshi.reddian.cn"